<template>
    <div v-if="fullData">
        <form-wizard
            color="rgba(var(--vs-primary), 1)"
            class="custom-form-wizard"
            :start-index="nextStep"
            :title="null"
            :subtitle="null"
            finishButtonText="Submit"
            @on-complete="formSubmitted"
        >
            <tab-content :title="$t('step_1')" class="mb-5">
                <vx-card class="">
                    <div class="text-center">
                        <span class="text-3xl font-semibold">{{
                            $t("questionnaire_title")
                        }}</span>
                    </div>
                    <vs-divider />
                    <div>
                        <span class="font-semibold">
                            {{ $t("questionnaire_step_1_title") }}
                        </span>
                        <vs-list>
                            <vs-list-item
                                :title="$t('questionnaire_list_1_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('questionnaire_list_2_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('questionnaire_list_3_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('questionnaire_list_4_title')"
                            ></vs-list-item>
                        </vs-list>
                        <vs-button
                            type="relief"
                            :to="{ name: 'questionnaire-applicant' }"
                            class="w-full mt-8"
                        >
                            {{
                                $t(
                                    fullData["is_ready"]["form"]
                                        ?"views"
                                        :"full_in"
                                )
                            }}
                        </vs-button>
                    </div>
                </vx-card>
            </tab-content>
            <tab-content :title="$t('step_2')" class="mb-5">
                <vx-card class="">
                    <div class="text-center">
                        <span class="text-3xl font-semibold">{{
                            $t("declaration_title")
                        }}</span>
                    </div>
                    <vs-divider />
                    <div>
                        <span class="font-semibold">
                            {{ $t("declaration_step_2_title") }}
                        </span>
                        <vs-list>
                            <vs-list-item
                                :title="$t('declaration_list_1_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('declaration_list_2_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('declaration_list_3_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('declaration_list_4_title')"
                            ></vs-list-item>
                            <vs-list-item
                                :title="$t('declaration_list_5_title')"
                            ></vs-list-item>
                        </vs-list>
                        <vs-button
                            type="relief"
                            :to="{ name: 'declaration-applicant' }"
                            class="w-full mt-8"
                        >
                            {{
                                $t(
                                    fullData["is_ready"]["application"]
                                        ?"views"
                                        :"full_in"
                                )
                            }}
                        </vs-button>
                    </div>
                </vx-card>
            </tab-content>
            <tab-content :title="$t('step_3')" class="mb-5">
                <vx-card class="">
                    <div class="text-center">
                        <span class="text-3xl font-semibold">{{
                            $t("documents_title")
                        }}</span>
                    </div>
                    <vs-divider />
                    <div>
                        <span class="font-semibold">
                            {{ $t("documents_step_3_title") }}
                        </span>

                        <span>
                            {{ $t("documents_information_text") }}
                        </span>

                        <vs-button
                            type="relief"
                            :to="{ name: 'additional-documents-applicant' }"
                            class="w-full mt-8"
                        >
                            {{
                                $t(
                                    fullData["is_ready"]["documents"]
                                        ?"views"
                                        :"full_in"
                                )
                            }}
                        </vs-button>
                    </div>
                </vx-card>
            </tab-content>
        </form-wizard>

        <div class=" m-0 m-auto px-5">

        <vs-card v-if="!fullData['changes_allowed']">
            <div class="flex flex-col md:flex-row items-center mb-4">
                <span class="text-lg font-semibold block mr-4">
                    {{ $t("status_application") }}:
                </span>
                <span>
                    {{ fullData["status_name"] }}
                </span>
            </div>

        </vs-card>

        <vs-card>
            <div v-if="comments && comments.length">
                <span class="text-lg font-semibold block mr-4">
                    {{ $t("status_application_comment") }}:
                </span>
                <template v-if="comments.length > 1">
                    <vs-button
                        type="relief"
                        class="mt-4 mb-4"
                        @click="showHistoryComment = !showHistoryComment"
                    >
                        {{ $t(showHistoryComment?"hide_history":"show_history") }}
                    </vs-button>
                    <template v-if="showHistoryComment">
                        <template v-for="(comment, index) in comments">
                            <template v-if="index !== 0">
                                <vs-card :key="comment.uid" class="ml-4">
                                    <BlockComment :data="comment" />
                                </vs-card>
                            </template>
                        </template>
                    </template>
                </template>
                 <vs-card class="ml-4">
                    <BlockComment :data="comments[0]" />
                 </vs-card>
            </div>
        </vs-card>
        <vs-button
            line-origin="left"
            class="w-full"
            color="success"
            type="relief"
            v-if="fullData['is_ready']['status']"
            :disabled="is_AWAITS_VERIFICATION"
            @click="sendApplication"
        >
            {{ $t("send_declaration") }}
        </vs-button>
        </div>

    </div>
</template>

<script>
    import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
    import "vue-form-wizard/dist/vue-form-wizard.min.css";
    import { mapState } from "vuex";
    import BlockComment from "@/pages/Home/FillingInTheApplicantsData/widgets/BlockComment";

    export default {
        name: "Page",
        data() {
            return {
                fullData: null,
                nextStep: 0,
                comments: null,
                showHistoryComment: false,
                is_AWAITS_VERIFICATION:false
            };
        },
        methods: {
            formSubmitted() {
                alert("Form submitted!");
            },
            async getFullData() {
                this.$vs.loading();
                try {
                    const response = await this.$http.get(
                        "admissions/applicants/data/",
                        {
                            params: {
                                profile: this.user.profileId,
                            },
                        }
                    );

                    this.nextStep = this.getIndexStep(response.data);

                    this.fullData = response.data;

                    this.is_AWAITS_VERIFICATION = (this.fullData.status_code === "AWAITS_VERIFICATION"||this.fullData.status_code === "REJECTED"||this.fullData.status_code === "APPROVED")&&(this.fullData.status_code !== "TO_IMPROVE");//проверка на статус отправки, показ кнопки "Подать заявку"

                } catch (e) {}
                this.$vs.loading.close();
            },
            async sendApplication() {
                try {
                    this.$vs.loading();

                    const response = (
                        await this.$http.patch(
                            `admissions/applicants/${ this.fullData.uid }/apply/`
                        )
                    ).data;
                    this.getFullData();
                    this.fullData["changes_allowed"] = false;
                } catch (e) {
                    this.$vs.notify({
                        text: this.$t("you_are_pending"),
                        color: "danger",
                    });
                } finally {
                    this.$vs.loading.close();
                }
            },
            getIndexStep(object) {
                if (object["is_ready"]["documents"]) {
                    return 2;
                } else if (object["is_ready"]["application"]) {
                    return 2;
                } else if (object["is_ready"]["form"]) {
                    return 1;
                } else {
                    return 0;
                }
            },
            async getCommentOfModerator() {
                try {
                    this.comments = (
                        await this.$http.get(
                            `admissions/applicants/${ this.fullData.uid }/comments/`
                        )
                    ).data;
                } catch (e) {
                } finally {
                }
            },
        },
        computed: {
            ...mapState({
                user: (state) => state.user.user,
            }),
        },
        components: {
            FormWizard,
            TabContent,
            WizardStep,
            BlockComment,
        },
        async created() {
            await this.getFullData();
            await this.getCommentOfModerator();
        },
    };
</script>

<style scoped lang="scss">
.custom-form-wizard::v-deep .wizard-card-footer {
    display: none;
}
</style>
